/**
 * V2-only Cashfree txn `orderDetails` (pilot_v2). Do not import legacy pilotCashfreeOrder.js from V2.
 * Same shape as legacy instore builder so Pilot webhook + Firestore stay compatible.
 */

/**
 * @param {string} userId
 * @param {object} pilotOrderPayload — body for Pilot POST /api/orders (no transactionRef yet)
 * @returns {{ cashfreeFlow: 'pilot_v2', pilotOrderPayload: object, userId: string, itemDetails: object }}
 */
export function buildPilotV2CashfreeOrderDetails({ userId, pilotOrderPayload }) {
  const products = pilotOrderPayload.products || [];
  const totalCount = products.reduce((sum, p) => sum + (Number(p.quantity) || 0), 0);

  const itemDetails = {
    totalAmount: Number(pilotOrderPayload.total) || 0,
    totalCount,
  };

  products.forEach((p, i) => {
    const key = String(p.productId ?? `line_${i}`);
    itemDetails[key] = {
      name: p.name,
      count: Number(p.quantity) || 0,
      price: Number(p.price) || 0,
      urlId: p.productId,
      imgUrls: p.imageUrl ? [p.imageUrl] : [],
    };
  });

  return {
    cashfreeFlow: 'pilot_v2',
    pilotOrderPayload,
    userId,
    itemDetails,
  };
}

/** Rupees with 2 decimals for Cashfree order_amount */
export function roundCashfreeOrderAmount(amount) {
  return Math.round(Number(amount) * 100) / 100;
}
